/**
 * 存储localStorage
 */
import {
    setCookie,
    getCookie,
    delCookie
} from '@/assets/cookie.js'
// Vue.prototype.$cookieStore={setCookie,getCookie,delCookie}
  //设置或跟新本地存储数据
//   export const Set_lsdata=(data_id, data) =>{
//     if (data_id != "") {
//         if (data) {
//             var lsobj = window.localStorage;
//             var datajson = JSON.stringify(data);
//             lsobj.setItem(data_id, datajson);
//         }
//     }
// }

// //获取本地存储数据
// export const Get_lsdata=(data_id)=> {
//     if (data_id != "") {
//         var data = null;
//         var lsdata = window.localStorage;
//         try {
//             var datajson = lsdata.getItem(data_id);
//             datajson = JSON.parse(datajson);
//             data = datajson;
//         } catch (e) {

//         } finally {
//             return data;
//         }
//     }
// }
export const setStore = (name, content) => {
    if (!name) return;
    if (typeof content !== 'string') {
        content = JSON.stringify(content);
    }
    window.localStorage.setItem(name, content);
}

/**
 * 获取localStorage中userinfo中的属性
 */
export const _getStore = name => {
	if (!name) return null;
    let value = window.localStorage.getItem('userinfo');
    if (value !== null) {
        try {
            let obj = JSON.parse(value);
            if(typeof obj == 'object' ) {
                for (let key in obj) {
                    if (name == key) {
                        return obj[key]
                    }
                }
            } else return obj
        } catch (e) {
            return obj
        }
    }
    return null;
}
/**
 * 获取localStorage
 */
export const getStore = name => {
    if (!name) return;
    var value = window.localStorage.getItem(name);
    if (value !== null) {
        try {
            value = JSON.parse(value);
        } catch (e) {
            value = value;
        }
    }
    return value;
}
export const _getAllCookie = () => {
    let value = getCookie("zbt_")
    return value
}
export const _getCookie = (name) => {
    if (!name) return;
    let value = getCookie("zbt_")
    if (value) {
        value = value.split(',')
        for (let i of value) {
            if (i.indexOf(name) != -1) {
                return i.split(':')[1];
            }
        }
    }
    return null
}
/**
 * 删除localStorage
 */
export const removeStore = name => {
    if (!name) return;
    window.localStorage.removeItem(name);
}

/**
 * 删除localStorage
 */
export const removeLoginInfo = () => {
    localStorage.removeItem('userinfo')
    localStorage.removeItem('menuData')
    delCookie("zbt_");
}

/**
 * 让整数自动保留2位小数
 */
// export const returnFloat = value => { 
//     var value=Math.round(parseFloat(value)*100)/100; 
//     var xsd=value.toString().split("."); 
//     if(xsd.length==1){ 
//         value=value.toString()+".00"; 
//         return value;   
//     } 
//     if(xsd.length>1){ 
//         if(xsd[1].length<2){ 
//             value=value.toString()+"0"; 
//         } 
//         return value; 
//     } 
// } 
/**
 * @param {date} 标准时间格式:Fri Nov 17 2017 09:26:23 GMT+0800 (中国标准时间)
 * @param {type} 类型
 *   type == 1 ---> "yyyy-mm-dd hh:MM:ss.fff"
 *   type == 2 ---> "yyyymmddhhMMss"
 *   type == '' ---> "yyyy-mm-dd hh:MM:ss"
 */
export const formatDate = (date, type) => {
    var year = date.getFullYear(); //年
    var month = date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1; //月
    var day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate(); //日
    var hour = date.getHours() < 10 ? "0" + date.getHours() : date.getHours(); //时
    var minutes = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes(); //分
    var seconds = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds(); //秒
    var milliseconds = date.getMilliseconds() < 10 ? "0" + date.getMilliseconds() : date.getMilliseconds() //毫秒
    if (type == 1) {
        return year + "-" + month + "-" + day + " " + hour + ":" + minutes + ":" + seconds + "." + milliseconds;
    } else if (type == 2) {
        return year + "" + month + "" + day + "" + hour + "" + minutes + "" + seconds;
    } else if (type == 3) {
        return year + "-" + month + "-" + day;
    } else {
        return year + "-" + month + "-" + day + " " + hour + ":" + minutes + ":" + seconds;
    }
}
/**
 * @function 输入年份月份判断一个月多少天
 */
export const mGetDate=(year, month)=>{
    var d = new Date(year, month, 0);
    return d.getDate();
}
/**
 * @function 日期比较 时间格式：Y-M-D
 */
export const compareDate = (date1, date2) => {
    date1 = date1.toString()
    date2 = date2.toString()
    let arys1 = new Array();
    let arys2 = new Array();
    if (date1 != null && date2 != null) {
        arys1 = date1.split('/');
        let time1 = parseInt(arys1[0] + arys1[1] + arys1[2]);
        arys2 = date2.split('-');
        let time2 = parseInt(arys2[0] + arys2[1] + arys2[2]);
        if (time1 > time2) {
            return false;
        } else {
            return true;
        }
    }
}
/**
 * 时间转换：20150101010101 --> '2015-01-01 01:01:01'
 */
export const parseToDate = (timeValue) => {
    // timevalue=JSON.stringify(timeValue)
    var result = "";
    var year = timeValue.substr(0, 4);
    var month = timeValue.substr(4, 2);
    var date = timeValue.substr(6, 2);
    var hour = timeValue.substr(8, 2);
    var minute = timeValue.substr(10, 2);
    var second = timeValue.substr(12, 2);
    result = year + "-" + month + "-" + date + " " + hour + ":" + minute + ":" + second;
    return result;
}
//导出EXcel
export function export2Excel(columns,list,listName){
    require.ensure([], () => {
        const { export_json_to_excel } = require('../vendor/Export2Excel');
        let tHeader = []
        let filterVal = []
      
        if(!columns){
            return;
        }
        columns.forEach(item =>{
            tHeader.push(item.title)
            filterVal.push(item.key)
        })
        const data = list.map(v => filterVal.map(j => v[j]))
        export_json_to_excel(tHeader, data, listName);
    })
}
//导出EXcel
export function export2ExcelTitle(columns,list,listName){
    require.ensure([], () => {
        const { export_json_to_excel } = require('../vendor/Export2Excel');
        let tHeader = []
        let filterVal = []
    let titleList=[]
        if(!columns){
            return;
        }
        // tHeader.push(title)
        columns.forEach(item =>{
          
            titleList.push(item.title)
            filterVal.push(item.key)
        })  
        const data = list.map(v => filterVal.map(j => v[j]))
        tHeader=data[0]
  data.splice(0,1)

        export_json_to_excel(tHeader, data, listName);
    })
}
/**
 * 判断空值
 */
export const isEmpty = (keys) => {
    if (typeof keys === "string") {
        keys = keys.replace(/\"|&nbsp;|\\/g, '').replace(/(^\s*)|(\s*$)/g, "");
        if (keys == "" || keys == null || keys == "null" || keys === "undefined") {
            return true;
        } else {
            return false;
        }
    } else if (typeof keys === "undefined") { // 未定义
        return true;
    } else if (typeof keys === "number") {
        return false;
    } else if (typeof keys === "boolean") {
        return false;
    } else if (typeof keys == "object") {
        if (JSON.stringify(keys) == "{}") {
            return true;
        } else if (keys == null) { // null
            return true;
        } else {
            return false;
        }
    }

    if (keys instanceof Array && keys.length == 0) { // 数组
        return true;
    }

}

/**
 * 返回两位的小数的字符串
 */
export const toFixedNum = (num) => {
    const tonum = Number(num).toFixed(2);
    return tonum;
}

export const showMessage = () => {
    this.$message({
        showClose: true,
        message: '对不起，您暂无此操作权限~',
        type: 'success'
    });
}

/**
 * 读取base64
 */
export const readFile = file => {
    
    //var file = this.files[0];
    //判断是否是图片类型
    if (!/image\/\w+/.test(file.raw.type)) {
        alert("只能选择图片");
        return false;
    }
    var reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function (e) {
        var filedata = {
            filename: file.name,
            filebase64: e.target.result
        }
        alert(e.target.result)
    }
}

/**
 * 需要递归循环children,重新赋值component
 */
export const generateRoutesFromMenu = (menuData = [], routes = [], componentNew) => {
    for (var i = 0; i < menuData.length; i++) {
        const menuobj = menuData[i]
        const component = menuData[i].component
        if (component && component !== 'content') {
            componentNew = require('page/' + menuData[i].component + '.vue')
        } else {
            componentNew = require('layout/' + menuData[i].component + '.vue')
        }
        menuobj['component'] = componentNew
        routes.push(menuobj)
        generateRoutesFromMenu(menuobj.children)
    }
    return routes
}
//除法函数，用来得到精确的除法结果 
//说明：javascript的除法结果会有误差，在两个浮点数相除的时候会比较明显。这个函数返回较为精确的除法结果。 
//调用：accDiv(arg1,arg2) 
//返回值：arg1除以arg2的精确结果 

export const accDiv=(arg1,arg2)=>{ 
    var t1=0,t2=0,r1,r2; 
  try{t1=arg1.toString().split(".")[1].length}catch(e){} 
  try{t2=arg2.toString().split(".")[1].length}catch(e){} 
    
  r1=Number(arg1.toString().replace(".","")); 
  
  r2=Number(arg2.toString().replace(".","")); 
  return (r1/r2)*Math.pow(10,t2-t1); 
    
    } 
    //给Number类型增加一个div方法，调用起来更加方便。 
    // Number.prototype.div = function (arg){ 
    // return accDiv(this, arg); 
    // } 
    
    //乘法函数，用来得到精确的乘法结果 
    //说明：javascript的乘法结果会有误差，在两个浮点数相乘的时候会比较明显。这个函数返回较为精确的乘法结果。 
    //调用：accMul(arg1,arg2) 
    //返回值：arg1乘以arg2的精确结果 
    export const accMul=(arg1,arg2)=>{
        var m=0,s1=arg1.toString(),s2=arg2.toString();
        try{m+=s1.split(".")[1].length}catch(e){}
        try{m+=s2.split(".")[1].length}catch(e){}
        return Number(s1.replace(".",""))*Number(s2.replace(".",""))/Math.pow(10,m)

    }
    // //给Number类型增加一个mul方法，调用起来更加方便。 
    // Number.prototype.mul = function (arg){ 
    // return accMul(arg, this); 
    // } 
    
    //加法函数，用来得到精确的加法结果 
    //说明：javascript的加法结果会有误差，在两个浮点数相加的时候会比较明显。这个函数返回较为精确的加法结果。 
    //调用：accAdd(arg1,arg2) 
    //返回值：arg1加上arg2的精确结果 
    export const accAdd=(arg1,arg2)=>{ 
    var r1,r2,m; 
    try{r1=arg1.toString().split(".")[1].length}catch(e){r1=0} 
    try{r2=arg2.toString().split(".")[1].length}catch(e){r2=0} 
    m=Math.pow(10,Math.max(r1,r2)) 
    return (arg1*m+arg2*m)/m 
    } 
    // //给Number类型增加一个add方法，调用起来更加方便。 
    // Number.prototype.add = function (arg){ 
    // return accAdd(arg,this); 
    // } 
    
    //减法函数，用来得到精确的减法结果 
    //说明：javascript的减法结果会有误差，在两个浮点数相加的时候会比较明显。这个函数返回较为精确的减法结果。 
    //调用：accSubtr(arg1,arg2) 
    //返回值：arg1减去arg2的精确结果 
    export const accSubtr=(arg1,arg2)=>{
    var r1,r2,m,n;
    try{r1=arg1.toString().split(".")[1].length}catch(e){r1=0}
    try{r2=arg2.toString().split(".")[1].length}catch(e){r2=0}
    m=Math.pow(10,Math.max(r1,r2));
    //动态控制精度长度
    n=(r1>=r2)?r1:r2;
    return ((arg1*m-arg2*m)/m).toFixed(n);
    } 

    // //给Number类型增加一个subtr 方法，调用起来更加方便。 
    // Number.prototype.subtr = function (arg){ 
    // return accSubtr(arg,this); 
    // } 



// WEBPACK FOOTER //
// ./src/utils/mUtils.js